import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import "./HeaderTitle.css"

function HeaderTitle({ title, description, isShowBack, backTo, customRight, style }) {
    return (
        <div className="title-header" style={style}>
            <div className="left-section">
                { isShowBack ?
                <Link to={backTo} className="back-button">
                    <FontAwesomeIcon icon={faArrowLeft}/>
                </Link>
                : null
                }
                <div>
                    <div className="title">{title}</div>
                    <div className="desc">{description}</div>
                </div>
            </div>
            <div className="right-section">
                {customRight}
            </div>
        </div>
    )
}

export default HeaderTitle
